import demoContent from './demoContent.json';
import demoContentExtra from './demoContentExtra.json';

const SECTION_KEYS = [
  { kvp_id: 'content_section', kvp_key_id: 'content_section_001', kvp_key: 'brand', kvp_key_name: '品牌专区', chs: '品牌专区', eng: 'Brand Zone', sequence: 1 },
  { kvp_id: 'content_section', kvp_key_id: 'content_section_002', kvp_key: 'medical', kvp_key_name: '医学服务', chs: '医学服务', eng: 'Medical Service', sequence: 2 },
  { kvp_id: 'content_section', kvp_key_id: 'content_section_003', kvp_key: 'tool', kvp_key_name: '临床工具', chs: '临床工具', eng: 'Clinical Tools', sequence: 3 },
  { kvp_id: 'content_section', kvp_key_id: 'content_section_004', kvp_key: 'mbc', kvp_key_name: 'MBC 咨询', chs: 'MBC 咨询', eng: 'MBC Consulting', sequence: 4 },
];

const CATEGORY_KEYS = [
  ...demoContent.kvpKeys,
  { kvp_id: 'content_category', parent_kvp_key_id: 'content_section_003', kvp_key_id: 'content_category_010', kvp_key: 'content_category_010', kvp_key_name: '随访工具', chs: '随访工具', eng: 'Follow-up Tools', sequence: 10 },
  { kvp_id: 'content_category', parent_kvp_key_id: 'content_section_003', kvp_key_id: 'content_category_011', kvp_key: 'content_category_011', kvp_key_name: '量表解读', chs: '量表解读', eng: 'Scale Interpretation', sequence: 11 },
  { kvp_id: 'content_category', parent_kvp_key_id: 'content_section_004', kvp_key_id: 'content_category_012', kvp_key: 'content_category_012', kvp_key_name: 'MBC 实践', chs: 'MBC 实践', eng: 'MBC Practice', sequence: 12 },
];

export const DEMO_PRODUCTS = [
  { product_id: 'Brintellix_000001', product_name: 'Brintellix', pathology_id: 'product_or_disease_0006' },
  { product_id: 'Azilect_000001', product_name: 'Azilect', pathology_id: 'product_or_disease_0007' },
  { product_id: 'Ebixa_000001', product_name: 'Ebixa', pathology_id: 'product_or_disease_0008' },
  { product_id: 'Vyepti_000001', product_name: 'Vyepti', pathology_id: 'product_or_disease_0009' },
];

const PRODUCT_KVP_KEYS = DEMO_PRODUCTS.map((product, index) => ({
  kvp_id: 'product',
  kvp_key_id: product.product_id,
  kvp_key: product.product_id,
  kvp_key_name: product.product_name,
  chs: product.product_name,
  eng: product.product_name,
  sequence: index + 1,
}));

const allRawContents = [
  ...demoContent.contents,
  ...demoContentExtra.contents,
];

function parsePathologyList(content) {
  try {
    const list = JSON.parse(content.pathology || '[]');
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}

function getPrimaryProduct(content) {
  const pathology = parsePathologyList(content)[0];
  return DEMO_PRODUCTS.find(product => product.pathology_id === (pathology && pathology.pathology_id)) || DEMO_PRODUCTS[0];
}

function buildRecommendedWording(content) {
  return [
    `## 简短版\n${content.content_name}这篇内容适合您近期关注的诊疗沟通场景，方便时可以快速浏览其中的要点。`,
    `## 交流版\n想和您分享一篇关于${content.description || content.content_name}的资料，里面整理了门诊沟通和随访管理中的几个实用观察点。`,
  ].join('\n\n');
}

function imageUrl(contentId) {
  return `/resource/demo-articles/${contentId}.png`;
}

function buildBody(content) {
  const src = imageUrl(content.content_id);
  return `<div class="demo-article-long-image" style="background:#f6f8f7;padding:0;margin:0;"><img src="${src}" alt="${content.content_name}" style="display:block;width:100%;height:auto;margin:0 auto;" /></div>`;
}

function toDemoContent(content) {
  const pathologies = parsePathologyList(content);
  const product = getPrimaryProduct(content);
  return {
    ...content,
    content_type: '图文',
    is_valid: 1,
    is_hcp360: 1,
    is_promo: content.is_promo === 0 ? 0 : 1,
    thumb: imageUrl(content.content_id),
    long_image: imageUrl(content.content_id),
    content_body: buildBody(content),
    s3_file_name: '',
    comment: content.description,
    recommended_wording: buildRecommendedWording(content),
    content__content_pathologies: pathologies.map(pathology => ({
      content_id: content.content_id,
      pathology_id: pathology.pathology_id,
      pathology,
    })),
    content__content_products: [{
      content_id: content.content_id,
      product_id: product.product_id,
      product,
    }],
  };
}

export const DEMO_CONTENTS = allRawContents.map(toDemoContent);

export function getDemoKvpByKvpId(kvpId) {
  const value = [
    ...SECTION_KEYS,
    ...CATEGORY_KEYS,
    ...PRODUCT_KVP_KEYS,
  ].filter(item => item.kvp_id === kvpId);
  return Promise.resolve({ value });
}

export function getDemoKvpByKvpIdAndParent(kvpId, parentKvpKeyId) {
  const value = CATEGORY_KEYS.filter(item => item.kvp_id === kvpId && item.parent_kvp_key_id === parentKvpKeyId);
  return Promise.resolve({ value });
}

export function getDemoPathologies() {
  return Promise.resolve({
    value: demoContent.pathologies.map(pathology => ({
      ...pathology,
      is_promo: 1,
    })),
  });
}

export function getDemoContents(contentName = '', pathology = '', section = '', category = '') {
  const keyword = String(contentName || '').trim().toLowerCase();
  const value = DEMO_CONTENTS
    .filter(content => !keyword || `${content.content_name} ${content.description}`.toLowerCase().includes(keyword))
    .filter(content => !pathology || content.content__content_pathologies.some(item => item.pathology_id === pathology))
    .filter(content => !section || content.content_section_kvp === section)
    .filter(content => !category || content.content_category_kvp === category)
    .sort((a, b) => new Date(b.publish_date).getTime() - new Date(a.publish_date).getTime());

  return Promise.resolve({ value });
}

export function getDemoContentById(contentId) {
  const value = DEMO_CONTENTS.filter(content => content.content_id === contentId);
  return Promise.resolve({ value, data: value });
}

export function getDemoAllContentSend(physicianId) {
  const value = DEMO_CONTENTS.slice(0, 6).map((content, index) => ({
    log_content_send_id: `demo-send-${physicianId}-${index}`,
    receiver_physician_id: physicianId,
    content_id: content.content_id,
    send_time: new Date(Date.now() - (index + 1) * 86400000).toISOString(),
    content,
  }));
  return Promise.resolve({ value });
}

export function getDemoAllContentOpen(physicianId) {
  const value = DEMO_CONTENTS.slice(0, 4).map((content, index) => ({
    log_content_open_id: `demo-open-${physicianId}-${index}`,
    physician_id: physicianId,
    content_id: content.content_id,
    open_time: new Date(Date.now() - (index + 1) * 72000000).toISOString(),
    duration: 45 + index * 38,
    content,
  }));
  return Promise.resolve({ value });
}

export function getDemoPhysicianContentSend(physicianId, contentId) {
  return Promise.resolve({
    value: [{
      log_content_send_id: `demo-send-${physicianId}-${contentId}`,
      receiver_physician_id: physicianId,
      content_id: contentId,
      send_time: new Date(Date.now() - 86400000).toISOString(),
    }],
  });
}

export function getDemoPhysicianContentOpen(physicianId, contentId) {
  return Promise.resolve({
    value: [{
      log_content_open_id: `demo-open-${physicianId}-${contentId}`,
      physician_id: physicianId,
      content_id: contentId,
      open_time: new Date(Date.now() - 43200000).toISOString(),
      duration: 126,
    }],
  });
}

export function getDemoContentSendOpenStats() {
  return Promise.resolve({
    isSuccess: true,
    data: {
      target_send_count: 150,
      send_count: 86,
      open_count: 54,
      open_rate: 0.63,
      avg_duration: 118,
      month_stats: [
        { month: '2026-04', send_count: 24, open_count: 15 },
        { month: '2026-05', send_count: 31, open_count: 20 },
        { month: '2026-06', send_count: 31, open_count: 19 },
      ],
    },
  });
}

export function getDemoPhysicianContentSendOpenStats(params = {}) {
  const pageIndex = Number(params.page_index || 1);
  const pageSize = Number(params.page_size || 20);
  const rows = DEMO_CONTENTS.slice(0, 18).map((content, index) => ({
    physician_id: `demo-physician-${String(index % 9 + 1).padStart(2, '0')}`,
    physician_name: ['陈晓明', '李婉清', '王志远', '赵一鸣', '周静', '刘思远', '孙嘉宁', '黄俊杰', '吴佳怡'][index % 9],
    sex: index % 3 === 0 ? '女' : '男',
    institution_name: ['上海市精神卫生中心', '北京协和医院', '华山医院', '中山医院'][index % 4],
    department_name: ['精神科', '神经内科', '老年医学科', '疼痛科'][index % 4],
    content_id: content.content_id,
    content_name: content.content_name,
    send_count: 1 + (index % 3),
    open_count: index % 2 === 0 ? 1 : 0,
    interaction_detail: [
      {
        interaction_type: '发送',
        interaction_time: new Date(Date.now() - (index + 1) * 86400000).toISOString(),
        duration: 0,
      },
      {
        interaction_type: '打开',
        interaction_time: new Date(Date.now() - (index + 1) * 64800000).toISOString(),
        duration: 60 + index * 7,
      },
    ],
  }));
  const start = (pageIndex - 1) * pageSize;

  return Promise.resolve({
    isSuccess: true,
    data: rows.slice(start, start + pageSize),
    data_count: rows.length,
  });
}
